
import { Options, Vue } from "vue-class-component";
import moment from "moment";
import i18n from "@/i18n";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { ServiceDelayController } from "@/app/ui/controllers/ServiceDelayController";
import {
  BookingSdnState,
  bookingDistrictCode
} from "@/app/ui/controllers/booking-sdn-state";

@Options({
  props: {
    originDistrict: { type: [Object, String], default: null },
    destinationDistrict: { type: [Object, String], default: null },
    active: { type: Boolean, default: true },
    contextLabel: { type: String, default: "" },
    variant: { type: String, default: "v4" }
  },
  watch: {
    requestKey: { immediate: true, handler: "refresh" }
  }
})
export default class BookingSdnBanner extends Vue {
  originDistrict!: unknown;
  destinationDistrict!: unknown;
  active!: boolean;
  contextLabel!: string;
  variant!: string;
  state = new BookingSdnState();

  get codes() {
    return {
      origin: bookingDistrictCode(this.originDistrict),
      destination: bookingDistrictCode(this.destinationDistrict)
    };
  }

  get requestKey(): string {
    return JSON.stringify([
      this.active,
      this.codes.origin,
      this.codes.destination
    ]);
  }

  get message(): string {
    const locale = AccountController.accountData.accountIsForeign ? "en" : "id";
    return i18n.global.t("bookingSdn.notice", {}, { locale });
  }

  refresh(): void {
    if (!this.active) return this.state.clear();
    const date = moment()
      .utcOffset(7 * 60)
      .format("YYYY-MM-DD");
    void this.state.refresh(this.codes, date, (params) =>
      ServiceDelayController.checkSdn(params)
    );
  }

  beforeUnmount(): void {
    this.state.clear();
  }
}
